<script>
import GSTC from 'gantt-schedule-timeline-calendar';
import {Plugin as TimelinePointer} from 'gantt-schedule-timeline-calendar/dist/plugins/timeline-pointer.esm.min.js';
import 'gantt-schedule-timeline-calendar/dist/style.css';
import {serbianDateFormat, snakeToWords} from "@/state/helpers";
import { Plugin as HighlightWeekends } from 'gantt-schedule-timeline-calendar/dist/plugins/highlight-weekends.esm.min.js';
import { Plugin as TimeBookmarks } from 'gantt-schedule-timeline-calendar/dist/plugins/time-bookmarks.esm.min.js';
import { Plugin as CalendarScroll } from 'gantt-schedule-timeline-calendar/dist/plugins/calendar-scroll.esm.min.js';
import AgreedContent from "@/components/clientNegotiations/AgreedContent";
import axios from "axios";

let gstc, state;

const DAYS_BEFORE_AND_AFTER_BUFFER = 90;

function getSocialNetworkIcon(socialNetwork) {
  let socialNetworkIcon = socialNetwork;
  if (socialNetwork === 'instagram') {
    socialNetworkIcon = 'bx bxl-instagram-alt'
  } else if (socialNetwork === 'facebook') {
    socialNetworkIcon = 'bx bxl-facebook-square'
  } else if (socialNetwork === 'youtube') {
    socialNetworkIcon = 'bx bxl-youtube'
  } else if (socialNetwork === 'blog') {
    socialNetworkIcon = 'fas fa-blog'
  }

  return socialNetworkIcon
}

// helper functions
function headerOuterSlot(vido, props) {
  const {html, api} = vido;

  return (content) => {
    if (api.sourceID(props.column.id) === 'price') {
      return html`<div class="text-right">${content}</div>`
    }

    return content;
  }
}

function  itemInnerSlot(vido, props) {
  const {html, onChange, update} = vido;

  let socialNetwork = '';
  let backgroundClass = '';
  onChange((newProps) => {
    props = newProps;
    if (!props) return;
    socialNetwork = props.item.socialNetwork;
    backgroundClass = `btn-${socialNetwork}`
    update();
  });


  return (content) => {
    return html`
      <style>
        .gstc__chart-timeline-items-row-item-label {mask-image: unset !important; -webkit-mask-image: unset;}
      </style>
      <div class="${backgroundClass} has-pointer-cursor ml-1" style="border-radius: 4px">${content}</div>
    `
  }
}


// main component
export default {
  components: {AgreedContent},
  props: {
    campaignEvents: {
      type: Array,
      required: true,
    },
    campaign: {
      type: Object,
      required: true,
    },
  },
  computed: {
    scrollToTodayEnabled() {
      const start = GSTC.api
          .date(new Date(this.campaign.start_date))
          .subtract(DAYS_BEFORE_AND_AFTER_BUFFER, 'day')
          .startOf('day')
      const end = GSTC.api
          .date(new Date(this.campaign.end_date))
          .add(DAYS_BEFORE_AND_AFTER_BUFFER, 'day')
          .startOf('day');

      if (start > GSTC.api.date() || end < GSTC.api.date()) {
        return false;
      }
      return true;
    },
  },
  data() {
    return {
      isScrollRepaired: false,

      items: {},
      rows: {},
      bookmarks: {},

      showAgreedPostModal: false,
      agreedPost: null,
    }
  },
  async created() {
    await this.generateRowsAndItems()
    this.generateBookmarks()

    /**
     * @type { import("gantt-schedule-timeline-calendar").Config }
     */
    const config = {
      licenseKey: 'new',
      plugins: [
        TimelinePointer(),
        HighlightWeekends(),
        TimeBookmarks(),
        CalendarScroll(),
        TimeBookmarks({
          bookmarks: this.bookmarks,
        }),
      ],
      scroll: {
        horizontal: {
          multiplier: 1,
        }
      },
      list: {
        expander: {
          padding: 5,
          icons: {
            child:
                '<?xml version="1.0" encoding="UTF-8"?><svg xmlns="http://www.w3.org/2000/svg" width="1" height="1"/>',
          },
        },
        sort: {
          asc: false,
          activeColumnId: GSTC.api.GSTCID('scheduled'),
        },
        row: {
          height: 50,
        },
        columns: {
          data: {
            // [GSTC.api.GSTCID('id')] :{
            //   id:GSTC.api.GSTCID('id'),
            //   width:60,
            //   data:({row})=>GSTC.api.sourceID(row.id),
            //   header:{
            //     content:'ID'
            //   }
            // },
            [GSTC.api.GSTCID('label')]: {
              id: GSTC.api.GSTCID('label'),
              // width: 300,
              data: 'label',
              header: {
                content: 'Post'
              },
              expander: true,
            },
            [GSTC.api.GSTCID('scheduled')]: {
              id: GSTC.api.GSTCID('scheduled'),
              sortable: ({ row }) => -(row.scheduled),
              data: 'scheduled',
              header: {
                content: 'Scheduled'
              },
            },
            [GSTC.api.GSTCID('price')]: {
              id: GSTC.api.GSTCID('price'),
              sortable: ({ row }) => -row.price,
              data: 'price',
              header: {
                content: 'Price'
              },
            },
          }
        },
        rows: this.rows
      },
      actions: {
        'chart-calendar-date': [this.fixScroll],
      },
      chart: {
        time: {
          period: 'day',
          from: GSTC.api
              .date(new Date(this.campaign.start_date))
              .subtract(DAYS_BEFORE_AND_AFTER_BUFFER, 'day')
              .startOf('day')
              .valueOf(),
          to: GSTC.api
              .date(new Date(this.campaign.end_date))
              .add(DAYS_BEFORE_AND_AFTER_BUFFER, 'day')
              .startOf('day')
              .valueOf(),
        },
        items: this.items,
        item: {
          height: 40,
        },
      },
      slots: {
        'chart-timeline-items-row-item': { content: [this.itemSlot], inner: [itemInnerSlot] },
        'list-column-row': {content: [this.rowSlot]},
        'list-column-header': {outer: [headerOuterSlot]},
      },
      innerHeight: 50 * (Object.keys(this.rows).length + 1),
    };

    state = GSTC.api.stateFromConfig(config);

    gstc = GSTC({
      element: this.$refs.gstc,
      state,
    });
    document.getElementsByClassName('gstc__chart')[0].addEventListener('wheel', function(t) {

      // Extracted from gstc.esm.
      // Fixan skrol koji je leteo na sve strane na trackpad-u, ne pitaj kako znamo da ovo radi.
      function normalizeMouseWheelEvent(t) {
        let e = t.deltaX || 0, i = t.deltaY || 0, n = t.deltaZ || 0;
        const s = t.deltaMode, o = gstc.state.get("config.list.row.height");
        let r = 1;
        switch (s) {
          case 1:
            o && (r = o);
            break;
          case 2:
            r = window.height
        }
        return e *= r, i *= r, n *= r, {x: e, y: i, z: n, event: t}
      }
      const e = normalizeMouseWheelEvent(t);

      if (Math.abs(e.x) > Math.abs(e.y) && Math.abs(t.deltaX) > 1.3) {
        e.y = 0
      } else {
        e.x = 0;
        t.stopPropagation()
      }

      return {}
    })

    document.getElementsByClassName('gstc__list')[0].addEventListener('wheel', function(e) {
      e.stopPropagation()
    })
  },

  beforeDestroy() {
    if (gstc) gstc.destroy();
  },

  methods: {
    generateBookmarks() {
      const startDate = new Date(this.campaign.start_date)
      const endDate = new Date(this.campaign.end_date)

      const idStart = `start`;
      this.bookmarks[idStart] = {
        color: '#019dcb',
        time: GSTC.api
            .date(startDate)
            .startOf('day')
            .valueOf(),
        label: 'Campaign start date',
      };

      const idEnd = `end`;
      this.bookmarks[idEnd] = {
        color: '#019dcb',
        time: GSTC.api
            .date(endDate)
            .endOf('day')
            .valueOf(),
        label: 'Campaign end date',
      };
    },
    async generateRowsAndItems() {

      const rows = {};
      const items = {};

      const insertedInfluencers = new Set()
      this.campaignEvents.forEach((item, index) => {
        const parentId = GSTC.api.GSTCID(item.influencer_id);
        if (!insertedInfluencers.has(item.influencer_id)) {
          rows[parentId] = {
            id: parentId,
            expanded: true,
            label: item.username ? item.username : item.influencer_name,
            img: item.profile_picture_url,
            price: 0,
            scheduled: false,
            influencerId: item.influencer_id
          }

          insertedInfluencers.add(item.influencer_id);
        }

        if (item.total_gross_price) {
          rows[parentId].price = rows[parentId].price + item.total_gross_price
        }

        const id = GSTC.api.GSTCID(`${item._id}_${index}`);
        rows[id] = {
          id,
          label: `${snakeToWords(item.post_type)}` + (item.giveaway ? ' - giveaway' : '') + (item.event ? ' - event' : ''),
          socialNetwork: item.social_network,
          price: item.total_gross_price ? item.total_gross_price : 0,
          scheduled: item.publish_date ? new Date(item.publish_date) : null,
          parentId: GSTC.api.GSTCID(item.influencer_id),
        }


        if (item.publish_date) {
          let start = GSTC.api.date(new Date(item.publish_date)).startOf('day');
          const itemId = GSTC.api.GSTCID(item.agreed_post_id);
          const rowId = id;
          items[itemId] = {
            id: itemId,
            socialNetwork: item.social_network,
            agreedPostStatus: item.agreed_post_status,
            agreedPostId: item.agreed_post_id,
            label: snakeToWords(item.post_type),
            rowId,
            time: {
              start: start.valueOf(),
              end: start.clone().endOf('day').valueOf(),
            }
          }
        }
      })

      this.rows = rows;
      this.items = items;
    },


    changeZoomLevel() {
      state.update('config.chart.time.zoom', 21);
    },

    scrollToToday() {
      gstc.api.scrollToTime(GSTC.api
          .date(new Date())
          .subtract(1, 'day')
          .startOf('day')
          .valueOf(), false);
      this.isScrollRepaired = true
    },

    scrollToStart() {
      gstc.api.scrollToTime(GSTC.api
          .date(new Date(this.campaign.start_date))
          .subtract(1, 'day')
          .startOf('day')
          .valueOf(), false);
      this.isScrollRepaired = true
    },

    scrollToEnd() {
      gstc.api.scrollToTime(GSTC.api
          .date(new Date(this.campaign.end_date))
          .subtract(1, 'day')
          .startOf('day')
          .valueOf(), false);
      this.isScrollRepaired = true
    },

    fixScroll(el, data) {
      if (!this.isScrollRepaired) {
        data.api.scrollToTime(GSTC.api
            .date(new Date())
            .subtract(1, 'day')
            .startOf('day')
            .valueOf(), false);
        this.isScrollRepaired = true
      }

      return {}
    },

    itemSlot(vido, props) {
      const {html, onChange, update} = vido;

      let agreedPostId = null;
      let socialNetworkIcon = '';
      let agreedPostStatus = '';
      onChange((newProps) => {
        props = newProps;
        if (!props) return;

        socialNetworkIcon = getSocialNetworkIcon(props.item.socialNetwork);

        agreedPostStatus = props.item.agreedPostStatus
        agreedPostId = props.item.agreedPostId

        update();
      });

      return (content) =>
          html`
            <div class="item-text pr-2" @click=${() => this.openAgreedPost(agreedPostId)}>
              <div class="item-label font-size-12 text-capitalize" style="height: 15px">
                <i class="${socialNetworkIcon} font-size-12" style="vertical-align:middle;"></i>
                ${content}
               </div>
               <div class="font-size-11 text-capitalize">
                <i class="invisible ${socialNetworkIcon} font-size-12" style="vertical-align:middle;"></i>
                ${agreedPostStatus}
               </div>
            </div>`;
    },

    async openAgreedPost(agreedPostId) {
      this.$store.commit('loader/START_LOADING');
      try {
        const { data } = await axios.get(`/agreed-post/${agreedPostId}`);
        this.agreedPost = data;
        this.showAgreedPostModal = true;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e)
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },

    async closeAgreedPost() {
      try {
        await this.$store.dispatch('scheduled/getAgreedPostsData');
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e)
      }
    },

    updateItemContent(agreedPost) {
      const state = gstc.api.state
      const itemId = GSTC.api.GSTCID(agreedPost._id);
      // eslint-disable-next-line no-unused-vars
      state.update('config.chart.items.' + itemId + '.agreedPostStatus', (oldValue) => {
        return agreedPost.status;
      });
    },

    rowSlot(vido, props) {
      const {html, onChange, update, api} = vido;

      let influencerId = ';'
      let img = '';
      let socialNetwork = ''
      onChange((newProps) => {
        props = newProps;
        if (!props) return;
        influencerId = props.row.influencerId;
        img = props.row.img;
        socialNetwork = props.row.socialNetwork;
        update();
      });

      return (content) => {
        if (api.sourceID(props.column.id) === 'label') {
          if (influencerId && img) {
            return html`
                <div class="row-content-wrapper" style="display:flex;">
                  <div
                        class="row-image has-pointer-cursor"
                        style="background:url(${img}),transparent;border-radius:100%;width:34px;height:34px;vertical-align: middle;background-size: 100%;margin: 11px 11px 0px 0px;"
                        @click=${() => this.goToInfluencerProfile(influencerId)}
                    ></div>
                  <div class="row-content text-capitalize mr-2 has-pointer-cursor underline-on-hover" style="flex-grow:1;" @click=${() => this.goToInfluencerProfile(influencerId)}>${content}</div>
                </div>`
          } else if (influencerId) {
            return html`
                <div class="row-content-wrapper" style="display:flex;">
                  <div class="row-content text-capitalize mr-2 has-pointer-cursor underline-on-hover" style="flex-grow:1;" @click=${() => this.goToInfluencerProfile(influencerId)}>${content}</div>
                </div>`
          }

          return html`
                <div class="row-content-wrapper" style="display:flex; align-items:center">
                  <div class="icon-wrap">
                                        <img src="${require(`@/assets/images/brands/${socialNetwork}.png`)}" class="img-fluid" alt="">
                                    </div>
                  <div class="row-content text-capitalize mr-2" style="flex-grow:1;">${content}</div>
                </div>`
        } else if (api.sourceID(props.column.id) === 'price') {
          if (content) {
            content = content.toLocaleString()
            return html`<div class="pr-2 text-right" style="border-right: 3px solid #dee2e6"><span>&euro;</span>${content}</div>`
          }

          return html`<div class="text-right pr-2 text-muted" style="border-right: 3px solid #dee2e6">N/A</div>`
        } else if (api.sourceID(props.column.id) === 'scheduled') {
          if (content) {
            content = serbianDateFormat(content)
            return html`<div class="pr-2">${content}</div>`
          } else if (content === false) {
            return '';
          }

          return html`<div class="text-muted">N/A</div>`
        }

        return content;
      }
    },

    goToInfluencerProfile(influencerId) {
      this.$router.push(`/client/influencers/${influencerId}`);
    }
  },
};
</script>

<template>
  <div>
    <div class="row toolbox position-absolute" style="margin-top: -53px">
<!--      <button @click="changeZoomLevel" class="btn btn-outline-primary">Change zoom level</button>-->
      <button v-if="scrollToTodayEnabled" @click="scrollToToday" class="btn btn-outline-primary btn-sm mr-3">Scroll to today</button>
      <button v-if="true" @click="scrollToStart" class="btn btn-outline-light btn-sm mr-3">Scroll to start</button>
      <button v-if="true" @click="scrollToEnd" class="btn btn-outline-light btn-sm">Scroll to end</button>
    </div>
    <div class="gstc-wrapper" ref="gstc"></div>

    <b-modal body-class="p-0" content-class="border-0" @hidden="closeAgreedPost" v-model="showAgreedPostModal" size="lg" centered hide-footer hide-header>
      <AgreedContent :agreed-post="agreedPost" @closeModal="showAgreedPostModal = false" @agreedPostChanged="updateItemContent"/>
    </b-modal>
  </div>
</template>

<style>
.gstc-component {
  margin: 0;
  padding: 0;
}

.toolbox {
  padding: 10px;
}

.gstc__chart-timeline-items-row-item {
  border-radius: 4px !important;
  background-color: transparent;
}

.icon-wrap {
    display: flex;
    align-items:center;
    position: relative;
    padding: 0;
    height: 16px;
    margin-right: 5px;
    width: 16px;
}
.icon-wrap img {
    position: absolute;
    display: inline-block;
}
</style>
